<template>
  <div class="msg-customer-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.keyword"
                 clearable
                 placeholder="输入手机号查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加/编辑的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="550"
            :mask-closable="false"
            :styles="styles">
      <div slot="header"
           class="chat_head">
        <div v-if="sendUser != null">
          <Avatar :src="sendUser.userdata.thumb"
                  icon="ios-person"
                  size="large" />
          <span class="usertitle">与“{{ sendUser.userdata.nickname+'('+sendUser.userdata.username+')' }}”聊天中</span>
        </div>
      </div>
      <div class="chat_list"
           v-if="sendUser != null">
        <div style="text-align: center"
             v-if="haveMore">
          <a href="javaScript:;"
             @click="showmore()">查看更多</a>
        </div>
        <div class="chat_item"
             v-for="(item,key) in chatlist">
          <p class="time">{{ item.created_at }}</p>
          <div class="get_chat clearfix"
               v-if="item.admin == null">
            <Avatar :src="item.userdata.thumb"
                    class="f-l"
                    icon="ios-person"
                    size="large" />
            <div class="chat_msg"
                 v-if="item.msg_type==1">{{ item.content }}</div>
            <div class="chat_msg"
                 v-else>
              <img :src="item.content"
                   style="width: 150px;height: auto;"
                   @click="showViewer(item.content)">
            </div>
          </div>
          <div class="send_chat clearfix"
               v-else>
            <Avatar class="f-r"
                    size="large"
                    style="color:#fff;background-color: #D40D0C">{{ item.admin.name }}</Avatar>
            <div class="chat_msg"
                 v-if="item.msg_type==1">{{ item.content }}</div>
            <div class="chat_msg"
                 v-else>
              <img :src="item.content"
                   style="width: 150px;height: auto;"
                   @click="showViewer(item.content)">
            </div>
          </div>
        </div>
      </div>
      <div class="demo-drawer-footer">
        <Form :model="msg"
              ref="msgValidate"
              :rules="msgValidate"
              action="javascript:void(0)"
              v-if="sendUser != null">
          <Row :gutter="8">
            <Col span="6">
            <Upload action="/common/upload/file"
                    :show-upload-list="false"
                    :format="['jpg', 'jpeg', 'png', 'gif']"
                    :max-size="7168"
                    :multiple="true"
                    :data="postData"
                    name="imgFile"
                    :on-success="handleSuccess"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize">
              <Button icon="md-photos">发送图片</Button>
            </Upload>
            </Col>
            <Col span="12">
            <FormItem label="">
              <Input v-model="msg.content"
                     :placeholder="'回复“'+ sendUser.userdata.nickname +'”...'"
                     @on-keydown="msgKeyDown"></Input>
            </FormItem>
            </Col>
            <Col span="6">
            <Button type="primary"
                    style="margin-right: 8px"
                    @click="submitMsg(1)">发送</Button>
            <Button type="error"
                    @click="showModalStatus = false">关闭</Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Drawer>
    <!-- <Modal v-model="showModalStatus" :title="title" @on-ok="submitMsg('msgValidate')" :loading="loading" :mask-closable="false">

        </Modal> -->
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
import UploadThumb from "../common/thumb"

export default {
  name: 'msg-customer-list',
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error('请上传封面图'));
      } else {
        callback();
      }
    };
    const validateContent = (rule, value, callback) => {
      if (this.msg.content == '') {
        callback(new Error('内容必须填写'));
      } else {
        callback();
      }
    };
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [], // v-viewer图片列表
      loading: true,
      dataloading: false,
      showModalStatus: false,  // 编辑添加弹窗
      isClear: false,
      formItem: {
        keyword: ''
      },
      postData: {
        thumb: 0,
        thumbWidth: "200px",
      },
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      columns1: [
        {
          title: '头像',
          key: 'thumb',
          width: 80,
          fixed: 'left',
          render: (h, params) => {
            const zUrl = "https://images.weserv.nl/?url=";
            let thumbImg = params.row.userdata == null ? '' : params.row.userdata.thumb;   //params.row.userdata.thumb.indexOf('https') > -1 ? zUrl + params.row.userdata.thumb : params.row.userdata.thumb;
            return h('div', [
              h('Avatar', {
                props: {
                  src: thumbImg
                },
              }, '')
            ]);
          }
        },
        {
          title: '昵称',
          key: 'nickname',
          width: 120,
          fixed: 'left',
          render: (h, params) => {
            let nickname = params.row.userdata == null ? '' : params.row.userdata.nickname;
            return h('span', {
            }, nickname);
          }
        },
        {
          title: '手机号',
          key: 'username',
          width: 120,
          fixed: 'left',
          render: (h, params) => {
            let username = params.row.userdata == null ? '' : params.row.userdata.username;
            return h('span', {
            }, username);
          }
        },
        {
          title: '未读消息',
          width: 100,
          render: (h, params) => {
            var unread_num = params.row.unread;
            if (unread_num != 0) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red',
                  }
                }, unread_num)
              ],);
            }
          }
        },
        {
          title: '最近聊天内容',
          key: 'content',
          tooltip: true,
          minWidth: 140,
          render: (h, params) => {
            let msg_type = params.row.msg_type;
            return h('span', {
            }, msg_type == 1 ? params.row.content : '[图片]');
          }
        },
        {
          title: 'uuid',
          key: 'uuid',
          tooltip: true,
          width: 280,
        },
        {
          title: '最近聊天时间',
          key: 'created_at',
          width: 160
        },
        {
          title: '操作',
          key: 'action',
          width: 80,
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showChat(params.row)
                  }
                }
              }, '查看'),
            ]);
          }
        }
      ],
      tablelist: [],
      chatlist: [],
      title: '',
      sendUser: null, // 点击查看时将用户信息存起来
      msg: {
        uuid: null,
        content: '',
      },
      msgValidate: {
        content: [
          { required: true, validator: '发送内容必须填写', trigger: "change" }
        ]
      },
      thumblist: [],
      haveMore: false,
      msgPage: {
        page: 1,
        size: 20
      }
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb,
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
    },
    // 获取消息列表
    getTableList: function () {
      var params = { page: this.pages.current, size: this.pages.size, keyword: this.formItem.keyword };
      this.$api.customermsg.userlist(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 客服消息发送监听回车
    msgKeyDown (event) {
      if (event.code == 'Enter') {
        this.submitMsg(1);
      }
    },
    showmore () {
      this.msgPage.page += 1;
      var ps = {
        uuid: this.sendUser.uuid,
        page: this.msgPage.page,
        size: this.msgPage.size
      };
      this.$api.customermsg.list(ps).then(res => {
        if (res.code == 200) {
          var newchatlist = res.result.list;
          for (let i = 0; i < this.chatlist.length; i++) {
            newchatlist.push(this.chatlist[i]);
          }
          this.chatlist = newchatlist;
          if (this.chatlist.length < res.result.total) {
            this.haveMore = true;
          } else {
            this.haveMore = false;
          }
        }
      })
    },
    submitMsg (msg_type) {
      // console.log('submitMsg:', name)
      var that = this
      // that.$refs[name].validate(valid => {
      // console.log(valid)
      // if (valid) {
      var ps = {
        uuid: that.msg.uuid,
        content: this.msg.content,
        msg_type: msg_type,
        page: 1,
        size: this.msgPage.size
      };
      that.$api.customermsg.reply(ps).then(res => {
        that.loading = false;
        if (res.code == 200) {
          that.chatlist = res.result.list;
          if (that.chatlist.length < res.result.total) {
            this.haveMore = true;
          } else {
            this.haveMore = false;
          }

          that.msg.content = '';
          var ele = document.getElementsByClassName("ivu-drawer-body")[0];
          if (ele.scrollHeight > ele.clientHeight) {
            setTimeout(function () {
              //设置滚动条到最底部
              ele.scrollTop = ele.scrollHeight;
            }, 100);
          }
          // var chat_list = document.querySelector('.chat_list').clientHeight
          // document.querySelector('.ivu-drawer-body').scrollTo( chat_list )
        }
      });
      // }
      // })

    },
    // 查看消息详情
    showChat: function (item) {
      item.unread = 0;
      this.msgPage.page = 1;
      var that = this;
      if (item) {
        that.sendUser = item;
      }
      this.chatlist = new Array();
      var msg = {
        uuid: that.sendUser.uuid,
        content: '',
      }
      this.msg = msg
      var ps = {
        uuid: that.sendUser.uuid,
        page: this.msgPage.page,
        size: this.msgPage.size
      };
      that.$api.customermsg.list(ps).then(res => {
        if (res.code == 200) {
          that.chatlist = res.result.list;
          if (that.chatlist.length < res.result.total) {
            this.haveMore = true;
          } else {
            this.haveMore = false;
          }
          that.showMsgModel()
        }
      })
    },
    showModel () {
      this.showMsgModel()
    },
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.getTableList();
    },
    showMsgModel () {
      // this.$refs["msgValidate"].resetFields();
      this.showModalStatus = true;
      setTimeout(function () {
        var ele = document.getElementsByClassName("ivu-drawer-body")[0];
        if (ele.scrollHeight > ele.clientHeight) {
          //设置滚动条到最底部
          ele.scrollTop = ele.scrollHeight;
        }
      }, 100);
    },
    change () {

    },
    renderTable: function (name) {
      if (name == 1) {
        this.pages.current = 1;
      }
      this.dataloading = true;
      this.getTableList();
    },
    showViewer (photo) {
      let imgs = [];
      imgs.push(photo);
      this.viewerImages = imgs;
      this.$viewer.show();
    },
    // 上传成功的回调
    handleSuccess (res, file) {
      if (res.code == 200) {
        console.log(res.result.url)
        var content = res.result.url;
        var that = this;
        var ps = {
          uuid: that.msg.uuid,
          content: content,
          msg_type: 2
        };
        that.$api.customermsg.reply(ps).then(res => {
          that.loading = false;
          if (res.code == 200) {
            that.chatlist.push({
              admin: {
                name: that.$store.getters.user_name,
              },
              content: content,
              msg_type: 2
            })
            var ele = document.getElementsByClassName("ivu-drawer-body")[0];
            if (ele.scrollHeight > ele.clientHeight) {
              setTimeout(function () {
                //设置滚动条到最底部
                ele.scrollTop = ele.scrollHeight;
              }, 100);
            }
          }
        });

      } else {
        this.$Notice.warning({
          title: "上传失败",
          desc: "请检查网络及上传的内容是否符合要求！",
        });
      }
    },
    // 检查文件格式
    handleFormatError (file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "文件 " + file.name + " 格式不正确, 请插入jpg/jpeg/png/gif图片。",
      });
    },
    // 检查大小
    handleMaxSize (file) {
      this.$Notice.warning({
        title: "文件大小超出限制",
        desc: "文件 " + file.name + " 太大，最大就不要超过2M！",
      });
    },
  },
}
</script>
<style scoped>
.chat_head .usertitle {
  margin-left: 15px;
  font-size: 14px;
  font-weight: bold;
}

.chat_list {
  padding: 0 0 20px 0;
}

.chat_item {
  margin: 0 0 10px 0;
  overflow: hidden;
}

.chat_item .time {
  padding: 5px;
  color: #999;
  font-size: 12px;
  text-align: center;
}

.chat_item .get_chat .chat_msg {
  position: relative;
  top: 5px;
  max-width: 350px;
  min-height: 34px;
  line-height: 24px;
  margin: 0 0 10px 15px;
  padding: 5px 8px;
  background: #eee;
  display: inline-block;
  border-radius: 5px;
  float: left;
  /* overflow: hidden; */
}

.chat_item .get_chat .chat_msg::before {
  content: "";
  width: 1px;
  height: 1px;
  border: 8px solid transparent;
  border-right-color: #eee;
  display: block;
  position: absolute;
  left: -7px;
  transform: rotate(-110deg);
}

.chat_item .send_chat .chat_msg {
  position: relative;
  top: 5px;
  max-width: 350px;
  min-height: 34px;
  line-height: 24px;
  margin: 0 15px 10px 0;
  padding: 5px 8px;
  background: #ffeaea;
  display: inline-block;
  border-radius: 5px;
  float: right;
  /* overflow: hidden; */
}

.chat_item .send_chat .chat_msg::before {
  content: "";
  width: 1px;
  height: 1px;
  border: 8px solid transparent;
  border-right-color: #ffeaea;
  display: block;
  position: absolute;
  right: -7px;
  transform: rotate(60deg);
}

.demo-drawer-footer .ivu-form-item {
  margin-bottom: 0;
}
</style>
